import React, { Fragment,useContext } from "react";
import { SbSection } from "./SbSection";
import { withRouter, Link } from "react-router-dom";
import { Checkbox } from "xsolla-uikit";
import { SbSelect } from './SbSelect';
import { T } from '../components/uikit-b2c/uikit-b2c';
import { methods } from '../components/uikit-b2c/methods';
import { ProductContext } from '../context'

export function PSsections1({
  psSections = {},
  handleSave = () => void 0,
  children,
  match,
  location,
  history
}) {

  const valueFromContext = useContext(ProductContext);

  const getMethods = (methods, change) => {
    Object.keys(methods).forEach((oneMethId, ind) => {
      methods[oneMethId]["on"] = true;
    });
    return methods;
  }


  const psConfig = { //TODO: сделать стирание локал стораджа если новая версия!
    cart: {
      // component: <PSsectionCart ps={this.ps} handleSave={(nw) => this.setStateFrom('ps', nw)}/>,
      section: {
        title: "Cart",
        urls: ["/ps/cart"],
      },
      items: {
        itemType: {
          label: 'Items in cart',
          value:  valueFromContext['psSections']['cart']['items']['itemType']['value'],
          handle: valueFromContext['psHandlers']['itemType'],
          controlType: "select",
          options: [
            {
              title: "Virtual Items",
              value:  "virtual_item",
            },
            {
              title: "Virtual Currency",
              value:  "virtual_currency",
            },
            {
              title: "Subscription",
              value:  "subscription",
            },
            {
              title: "Game",
              value:  "gamekey",
            },
            {
            title: "Several Games",
              value:  "gamekeys",
            },
          ],
        },


        // cartVar: {
        //   dependent: {
        //     id: "itemType",
        //     value: 'virtual_item',
        //   },
        //   label: 'Items in cart',
        //   value:  valueFromContext['psSections']['cart']['items']['cartVar'] ? valueFromContext['psSections']['cart']['items']['cartVar']['value'] : null,
        //   handle: valueFromContext['psHandlers']['cartVar'],
        //   controlType: "select",
        //   options: [
        //     {
        //       title: "One item",
        //       value:  "one",
        //     },
        //     {
        //       title: "Many items",
        //       value:  "many",
        //     },
        //   ],
        // },



        methods: {
          value:  methods,
          value:  getMethods(methods),
        },
        checkoutStyle: {
          label: "Checkout style:",
          value:  valueFromContext['psSections']['cart']['items']['checkoutStyle']['value'],
          controlType: "select",
          options: [
            {
              title: "Priority Payment methods",
              value:  "methods",
            },
            {
              title: "Pay now button",
              value:  "button",
            },
          ],
          handle: valueFromContext['psHandlers']['checkoutStyle'],
        },
        payment: {
          dependent: {
            id: "checkoutStyle",
            value: 'methods',
          },
          label: "Monochrome",
          value: valueFromContext['psSections']['cart']['items']['payment']['value'],
          controlType: "checkbox",
          handle: valueFromContext['psHandlers']['payment'],
        },
        login: {
          label: "Login",
          value: valueFromContext['psSections']['cart']['items']['login']['value'],
          controlType: "checkbox",
          handle: valueFromContext['psHandlers']['login'],
        },
      },
    },
    choose: {
      section: {
        title: "Payment methods",
        urls: ["/ps/choose"],
      },
    },
    method_card: {
      section: {
        title: "Payment method",
        urls: [
          "/ps/method_card",
          "/ps/method_pp",
          "/ps/method_cvs",
          "/ps/method_apple",
          "/ps/method_cash",
          "/ps/method_installments",
        ],
      },
      method: 0,
      items: {
        cardVisual: {
          label: "Card style:",
          value:  valueFromContext['psSections']['method_card']['items']['cardVisual']['value'],
          controlType: "select",
          options: [
            {
              title: "Old school card",
              value:  "oldschool",
            },
            {
              title: "Abstract",
              value:  "abstract",
            },
          ],
          handle: (nw) => {
            let newPS = { ...valueFromContext['psSections'] };
            newPS["method_card"]["items"]["cardVisual"]["value"] = nw;
            valueFromContext.setStateFrom("psSections", newPS);
          },
        },
        links: {
          controlType: "links",
          options: [
            {
              title: "Credit/Debit card",
              value:  "/ps/method_card",
            },
            {
              title: "Paypal",
              value:  "/ps/method_pp"
            },
            {
              title: "CSV",
              value:  "/ps/method_cvs"
            },
            {
              title: "Apple Pay",
              value:  "/ps/method_apple"
            },
            {
              title: "Cash",
              value:  "/ps/method_cash"
            },
            {
              title: "Installments",
              value:  "/ps/method_installments"
            },
          ],
        },
      },
    },
    status: {
      section: {
        title: "Status",
        urls: ["/ps/status"],
      },
      share: false,
      key: true,
      check: true,
    },
  };



  return (
    <Fragment>
      {Object.keys(psConfig).map((oneSectionName, ind) => {
        let oneSection = psConfig[oneSectionName];
        return (
          <SbSection
            key={`sect_${oneSection["section"]["urls"]}`}
            style={{paddingBottom: 8}}
            active={
              oneSection["section"]["urls"].includes(location.pathname)
                ? true
                : false
            }
            onClick={(e) => {
              if (e.target.nodeName !== 'A') {
                history.push(oneSection["section"]["urls"][0]);
              }
            }}
            title={oneSection["section"]["title"]}
            key={`sect_${ind}`}
          >
            {/* <PSsectionCart ps={ps} handleSave={handleSave}/> */}

            {oneSection["section"]["urls"].indexOf(location.pathname) > -1
            && oneSection["items"]
            && Object.keys(oneSection["items"]).map((oneSettingId, ind) => {
                let oneSetting = oneSection["items"][oneSettingId];

                if (!oneSetting['dependent'] || (oneSetting['dependent']
                  // && oneSetting['dependent']['id'] === oneSettingId
                  && oneSetting['dependent']['value'] === oneSection["items"][oneSetting['dependent']['id']]['value']
                  )

                ) {return (<div
                  key={`sett_${oneSettingId}_${ind}`}
                    style={{
                    marginBottom: oneSetting['dependent'] ? 16 : 0,
                    // marginTop: oneSetting['dependent'] ? -8 : 0,
                  }}>

                    <PScontrol
                      type={oneSettingId}
                      {...oneSetting}
                    />
                </div>)} else {return null}
            })}


          </SbSection>
        );
      })}
    </Fragment>
  );
}

export const PSsections = withRouter(PSsections1);




export function PScontrol({
  dependent,
  value,
  defaultValue,
  controlType,
  handle,
  label,
  options = [],
}) {


  value = value || defaultValue;
  return (


    <div style={{display:'flex'}}>

      {dependent && <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>}

      {controlType === "checkbox" && (
        <div
        className="xsb_but_link_input"
          onClick={handle}
          style={{
            padding: '6px 0 0 12px',
            // minHeight: 34,
            // height: 36,
          }}
        >
        <Checkbox
          name="slider"
          label={label}
          input={{
            value: value,
            onChange: handle
          }}
        />
        </div>
      )}

      {controlType === "select" && (
      <div style={{width: '100%'}}>
        {Boolean(label) && <div style={{marginBottom: '0.4em'}}>{label}</div>}
        <SbSelect
          active = {value}
          placeholder={label}
          menuHandler={handle}
          default = '123'
          options={options}
        />
      </div>
      )}


      {controlType === "links" && (
       <div style={{width: '100%'}}>
        {!!label && <div style={{marginBottom: '0.4em'}}>{label}</div>}
        {options.map((oneOpt, ind) => {
          return (<p key={`link_${ind}`}><Link className='xsb_link_white'  to={oneOpt['value']}>{oneOpt['title']}</Link></p>)})}
      </div>)}


    </div>
  );
}

export function PSsectionCart({ ps = {}, handleSave }) {
  return (
    <div className="">
      <Checkbox
        name="methods_cards_colors"
        label="Payment methods in original colors"
        input={{
          value: ps["cart"]["items"]["payment"]["monochrome"],
          onChange: () => {
            let newPS = { ...ps };
            newPS["cart"]["items"]["payment"]["monochrome"] = !newPS["cart"][
              "items"
            ]["payment"]["monochrome"];
            handleSave(newPS);
          }
        }}
      />
    </div>
  );
}
